import { EmbeddedYoutubeVideo } from '@dreamstack/feature-components/src/ui/EmbeddedYoutubeVideo'
import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { HeadingH2 } from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockVideo } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'

export const Video: FunctionComponent<
  React.PropsWithChildren<{ block: BlockVideo }>
> = ({ block }) => {
  const headline = block.headline
  if (!block.href) {
    console.error('skipped Video block because there was no href.')
    return null
  }
  return (
    <GridWithGaps className="col-span-full">
      <div className="col-span-full lg:col-start-2 lg:col-span-10">
        <HeadingH2>{headline}</HeadingH2>
        <div className="aspect-[16/9] relative mt-px-48">
          <EmbeddedYoutubeVideo fullYoutubeUrl={block.href} />
        </div>
      </div>
    </GridWithGaps>
  )
}
